import { Configs } from 'Constants';

export interface BasketResponse {
  numberOfProducts: string;
}

const getBasketQuantity = () =>
  fetch(Configs.pipeBasketQuantityEndpoint || '')
    .then((res) => res.json())
    .then((json) => json as BasketResponse)
    .then((basketResponse) => basketResponse.numberOfProducts)
    .then((numberOfProducts) => parseInt(numberOfProducts))
    .catch(() => 0);

export const BasketService = { getBasketQuantity };
